// extracted by mini-css-extract-plugin
export default {"alert":"Alert__alert--HYnGkQLGI62RaYoLO6vu"};